import ClientDto from '../client/client-dto';
import DomainStageDto from './domain-stage-dto';

export default class DomainDto
{
    public id: number|null = null;
    public client: ClientDto|null = null;
    public name = '';
    public comments: string|null = null;
    public stage: DomainStageDto|null = null;
    public registrar = '';
    public dateExpiry: string|null = null;
    public managed = false;
    public disabled = false;
    public dateAdded = '';
}